import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Verified = ({ color = '#313634', ...rest }: Props) => {
  return (
    <Svg
      width={60}
      height={57}
      viewBox="0 0 60 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.9344 56.5L15.8677 47.9667L6.26772 45.8333L7.20106 35.9667L0.667725 28.5L7.20106 21.0333L6.26772 11.1667L15.8677 9.03333L20.9344 0.5L30.0011 4.36667L39.0677 0.5L44.1344 9.03333L53.7344 11.1667L52.8011 21.0333L59.3344 28.5L52.8011 35.9667L53.7344 45.8333L44.1344 47.9667L39.0677 56.5L30.0011 52.6333L20.9344 56.5ZM27.2011 37.9667L42.2677 22.9L38.5344 19.0333L27.2011 30.3667L21.4677 24.7667L17.7344 28.5L27.2011 37.9667Z"
        fill={color}
      />
    </Svg>
  )
}

export default Verified
